<template>
  <div class="fae-item" @click="onDetail">
    <div class="fae-img">
      <van-card :thumb="faeLists.USER_IMAGE"/>
      <!--            <img src="@/assets/images/noavatar.gif">-->
      <!--            <img class="img-header" :src="this.CoreNew.JOA_URL+'images/user/'+faeLists.CODE+'.jpg'"  @error="onErrorImage">-->
      <!--            <img class="img-header" :src="faeLists.USER_IMAGE"  @error="onErrorImage">-->
      <!--            <img class="img-header" src="../../../assets/images/noavatar.gif"  @error="onErrorImage">-->
    </div>

    <div class="fae-info">
      <div class="full" v-if="faeLists.FAE_PERCENT && parseInt(100-faeLists.FAE_PERCENT) ==0">
        <span class="text">约满</span>
      </div>
      <div class="percent" v-else>
        <span class="text" v-if="faeLists.FAE_PERCENT == 0">全天可约</span>
        <span class="no" v-else>{{ parseInt(faeLists.FAE_PERCENT) }}%</span>
      </div>

      <div class="fae-info-i">
        <p><span class="name">{{ faeLists.NAME }}</span> <span class="ename">{{ faeLists.ENAME }}</span></p>
        <!--            <p class="department">{{faeLists.DEPARTMENT}}</p>-->
        <p class="department">{{ faeLists.POSITION_NAME }} <span v-if="faeLists.ACTUAL_LOCATION">● {{faeLists.ACTUAL_LOCATION}}</span></p>
        <div class="segment" v-if="faeLists.SEGMENT">
          <span class="text">应用领域：</span>
          <span class="list">{{ formatSegment }}</span>
        </div>
        <div class="productline">
          <ul>
            <li class="line" v-for="item in productline" :key="item">{{ item }}</li>
          </ul>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "faeItem",
  props: {
    faeLists: Object,
    search: Object
  },
  data() {
    return {
      WEB_URL: localStorage.getItem('LS_WEB_URL'),
      defaultImg: '../../../assets/images/noavatar.gif',
      source: ''
      // formatSegment:'', // 对领域数据格式化
    }
  },
  mounted(){
    if (this.CoreNew.WEB_URL_SOURCE) {
      this.source = this.CoreNew.WEB_URL_SOURCE
    }
  },
  computed: {
    productline() {
      let PRODUCT = this.faeLists.PRODUCT;
      let productline = []
      if (PRODUCT) {
        productline = PRODUCT.split(",");
      }
      return productline
    },
    formatSegment() {
      let SEGMENT = this.faeLists.SEGMENT;
      let segments = [],temsegments=[];
      if (SEGMENT) {
        segments = SEGMENT.split(",");
      }
      if(segments.length>0){
        temsegments =  segments.map(item=>{
          return item.split("(")[0]
        })
      }
      return temsegments.toString()
    },
  },
  methods: {
    // onErrorImage(e) {
    //     // console.log(e)
    //     console.log(this.defaultImg)
    //     let img = e.srcElement;
    //     console.log(img)
    //     img.src = this.defaultImg;
    //     img.onerror = null
    // },
    onDetail() {
      let ID = this.faeLists.ID;
      let searchData = this.search;
      this.$router.push({
        path: '/fae/detail',
        query: {
          id: ID,
          date: searchData.date,
          source:this.source
        }
      })
    }
  }

}
</script>

<style scoped lang="less">
//@import "../../../assets/css/base.less";

.fae-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 10px 0;


  .fae-img {
    width: 50px;
    height: 50px;
    border: 1px solid #eee;
    border-radius: 50%;
    overflow: hidden;
    margin: 0 20px;
    background: #fff;
    justify-content: center;
    align-items: center;
    display: flex;

    /deep/ .van-card {
      width: 50px;
      height: 50px;

      .van-card__thumb {
        width: 50px;
        height: 50px;

        .van-image__error {
          background: url("../../../assets/images/noavatar.gif");
          background-size: 50px 50px;
        }

        .van-icon-photo-fail::before {
          display: none;
        }
      }

    }


    .img-header {
      width: 50px;
    }

    .van-card {
      padding: 0;

      /deep/ .van-image {
        width: 50px;
        height: 50px;
      }

      .van-card__thumb {
        display: flex;
        align-items: center;
        justify-content: center;

        /deep/ img {
          width: 50px;
          height: 50px;
          border-radius: 50%;
        }
      }

    }


  }

  .fae-info {
    flex: 1;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    position: relative;
    min-height: 70px;

    .fae-info-i{
      width: 78%;
    }

    .label {
      position: absolute;
      right: 20px;
      top: 0;
      color: #fff;
      border-radius: 2px;
      background: @linearOrange;
      padding: 0 2px;
    }

    .percent {
      position: absolute;
      right: 20px;
      top: 0;
      font-size: 14px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 1px solid #ff6000;
      color: #ff6000;
      display: flex;
      justify-content: center;
      align-items: center;

      .text {
        font-size: 12px;
        width: 30px;
        text-align: center;
        line-height: 1;
      }

    }

    .full {
      position: absolute;
      right: 20px;
      top: 0;
      font-size: 14px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 1px solid #ddd;
      color: #999;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .name {
      font-size: 15px;
      font-weight: bold;
      color: @font3;
    }

    .ename {
      font-size: 14px;
      color: @font6;
      margin-left: 5px;
    }

    .department {
      font-size: 12px;
      color: @font9;
      margin-top: 5px;
    }

    .segment {
      color: @yellow;
      margin-top: 5px;
      max-height: 35px;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      opacity: .8;

      .text {
        white-space: nowrap;
      }

      .list {
        white-space: normal;
        word-break: break-all;
      }
    }

    .productline ul {
      display: flex;
      margin-top: 10px;
      margin-bottom: 10px;
      flex-wrap: wrap;

      .line {
        color: @green;
        border: 1px solid @green;
        border-radius: 2px;
        padding: 0 2px;
        margin-right: 5px;
        margin-bottom: 5px;
        font-size: 10px;
      }
    }
  }

  .fae-info::after {
    position: absolute;
    bottom: -5px;
    right: 20px;
    content: '';
    width: 94%;
    height: 1px;
    background: #eee;
  }
}

</style>